import * as XLSX from "xlsx";
import {
  HandleBulkInventoryApiReturn,
  InventoryData,
  PreparedDataReturn,
  TExcelData,
} from "../interface";

export const useUploadFile = () => {
  //function to prepared the data for show in table
  const prepareDataForTable = (
    data: InventoryData,
    secondaryData: PreparedDataReturn
  ): HandleBulkInventoryApiReturn[] => {
    return data.valid_products.map((product) => ({
      ...product,
      store: {
        id: data.store.id,
        store_name: data.store.store_name,
        store_location: data.store.store_location,
      },
      unit_const_amount:
        secondaryData?.product_details?.find(
          (item) => item.product_id === product.product_id_display
        )?.cost_amount ?? 0,
      remarks: secondaryData?.remark,
    }));
  };

  //function to convert json data to required format
  const preparedData = (data: TExcelData[]): PreparedDataReturn[] => {
    const storeMap = new Map<string, PreparedDataReturn>();

    for (const row of data) {
      // If store not created, initialize it
      if (!storeMap.has(row.Storecode)) {
        storeMap.set(row.Storecode, {
          store_code: row.Storecode,
          remark: row.Remark,
          product_details: [],
        });
      }

      const storeObj = storeMap.get(row.Storecode)!;

      // Find product object inside this store
      let product = storeObj.product_details.find(
        (p) => p.product_id === row["Product ID"]
      );

      if (!product) {
        // Create new product entry
        product = {
          product_id: row["Product ID"],
          cost_amount: row.Unitcost,
          quantity: 1,
          barcodes: [row.Barcode],
        };
        storeObj.product_details.push(product);
      } else {
        // Update existing product
        product.quantity += 1;
        product.barcodes.push(row.Barcode);
      }
    }

    return Array.from(storeMap.values());
  };

  // function to convert the data from excel to json
  const handleFileUpload = (
    e: any,
    handleFileData: (data: TExcelData[]) => void
  ) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      try {
        const data = event.target.result;
        if (typeof data === "string") {
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData: any = XLSX.utils.sheet_to_json(sheet);
          handleFileData(parsedData);
        } else {
          throw new Error("Invalid file data");
        }
      } catch (error) {
        console.error("Error parsing Excel file:", error);
      }
    };

    reader.onerror = (event: ProgressEvent<FileReader>) => {
      console.error("Error reading the file:", event?.target?.error);
    };

    if (e.target.files && e.target.files[0]) {
      reader.readAsBinaryString(e?.target?.files[0]);
    } else {
      console.error("No file selected");
    }
  };

  return { handleFileUpload, preparedData, prepareDataForTable };
};
